import { http } from '@/api/http'
import type { Payment } from '@/lib/pos-types'
import { normalizePayment, unwrapList } from '@/api/normalizers'

export const paymentsApi = {
  list: async (params?: { limit?: number }): Promise<Payment[]> => {
    const limit = params?.limit
    const query = typeof limit === 'number' ? `?limit=${encodeURIComponent(String(limit))}` : ''
    const res = await http.get<unknown>(`/payments${query}`)
    return unwrapList(res.data).map(normalizePayment)
  },
  get: async (paymentId: string): Promise<Payment> => {
    const res = await http.get<unknown>(`/payments/${encodeURIComponent(paymentId)}`)
    return normalizePayment(res.data)
  },
  create: async (payload: unknown): Promise<Payment> => {
    const res = await http.post<unknown>('/payments', payload)
    return normalizePayment(res.data)
  },
}
